import {
  formatDateTime,
  formatRelativeTime,
  isRecent,
} from "@/shared/datetime";

/** When something was verified: "3 minutes ago" within a day of `timestamp`, else its date and time. */
export function verifiedWhen(timestamp: string): string {
  return isRecent(timestamp)
    ? formatRelativeTime(timestamp)
    : formatDateTime(timestamp);
}
